'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00249 from "./presto.-Register-Page-View$$anon$9.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$8() {
  this.bv1 = null;
  this.buT = null;
  this.buU = false;
  this.bv2 = null;
  this.bv3 = false;
  this.bv6 = null;
  this.buZ = null;
  this.bv0 = false;
  this.buV = null;
  this.buW = false;
  this.buX = null;
  this.buY = false;
  this.bv4 = false;
  this.bv5 = false;
  this.bv1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bv6 = "CompactGroup";
}
export { $c_Lpresto_RegisterPageView$$anon$8 as $c_Lpresto_RegisterPageView$$anon$8 };
$p = $c_Lpresto_RegisterPageView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$8;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$8() {
}
export { $h_Lpresto_RegisterPageView$$anon$8 as $h_Lpresto_RegisterPageView$$anon$8 };
$h_Lpresto_RegisterPageView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bv1;
});
$p.L = (function() {
  if ((!this.buU)) {
    this.buT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.buU = true;
  }
  return this.buT;
});
$p.O = (function() {
  if ((!this.bv3)) {
    this.bv2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bv3 = true;
  }
  return this.bv2;
});
$p.E = (function() {
  return this.bv6;
});
$p.t = (function() {
  if ((!this.bv0)) {
    this.buZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bv0 = true;
  }
  return this.buZ;
});
$p.M = (function() {
  if ((!this.buW)) {
    this.buV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.buW = true;
  }
  return this.buV;
});
$p.Q = (function() {
  if ((!this.buY)) {
    this.buX = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00249.$c_Lpresto_RegisterPageView$$anon$9();
    this.buY = true;
  }
  return this.buX;
});
$p.w = (function() {
  if ((!this.bv5)) {
    this.bv4 = false;
    this.bv5 = true;
  }
  return this.bv4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee72) => ((p) => \u03b4scrutinee72.ad6(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_RegisterPageView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$8, "presto.RegisterPageView$$anon$8", ({
  Q6: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$8 as $d_Lpresto_RegisterPageView$$anon$8 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$8.js.map
